import { useAppSelector } from '@/hooks/use.redux';

export function useFcmToken() {
  const fcmToken = useAppSelector((reducer) => reducer.generalReducer.fcmToken);
  return {
    fcmToken,
  };
}
